<template>
  <el-dialog
    :title="$t('config.profile.title.importExcelDialog')"
    :visible.sync="importExcelVisible"
    width="70%"
    :close-on-click-modal="false"
    @close="onReset"
  >
    <tab v-model="tabIndex" :tab-list="tabList" />

    <div v-if="tabIndex === 1" class="tab-content">
      <div class="grid-scroll" style="height: 500px">
        <GridVx
          ref="infoGrid"
          class="agGrid"
          :columns="invoiceCols"
          :rows="rows[0]"
        />
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <div class="button-containers">
        <button
          class="btn primary small"
          @click="fnGetInvoiceCompanyExcelTemplate"
        >
          {{ 'Tải mẫu' }}
        </button>

        <!-- <input
          ref="excel-upload-input"
          class="excel-upload-input"
          type="file"
          accept=".xlsx, .xls"
          @change="handleClick"
        />
        <button class="btn primary small" @click="handleUpload">
          {{ 'Chọn tệp tin' }}
        </button> -->

        <UploadExcelBtn v-model="excelFile" @output="getDataFromExcelFile" />

        <button
          class="btn primary small"
          :disabled="!excelFile"
          @click="fnInsertListInvoiceCompanyExcel"
        >
          {{ 'Cập nhật' }}
        </button>
        <button
          class="btn primary small outline"
          @click="importExcelVisible = false"
        >
          {{ 'Huỷ' }}
        </button>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import Tab from '@/components/Tab'
import {
  getListInvoiceCompanyExcelTemplateApi,
  insertListInvoiceCompanyExcelApi
} from '@/api/configuration/profile/invoiceCompany'
import UploadExcelBtn from '../../components/UploadExcelBtn.vue'

export default {
  components: { Tab, UploadExcelBtn },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      importExcelVisible: this.value,
      tabIndex: 1, // 1 - 3

      rows: [],

      excelFile: null,

      excelData: {
        header: null,
        results: null
      }
    }
  },

  computed: {
    // tab
    tabList() {
      return [{ label: this.$t('config.profile.dialog.iTab1'), value: 1 }]
    },
    // grid
    invoiceCols() {
      return [
        {
          headerName: this.$t('config.profile.field.taxCode'),
          field: 'Mã số thuế'
        },
        {
          headerName: this.$t('config.profile.field.invoiceAgentName'),
          field: 'Tên công ty trên hóa đơn'
        },
        {
          headerName: this.$t('config.profile.field.address'),
          field: 'Địa chỉ'
        },
        {
          headerName: this.$t('config.profile.field.phone'),
          field: 'Số điện thoại'
        },
        {
          headerName: this.$t('config.profile.field.email'),
          field: 'Email'
        },
        {
          headerName: this.$t('config.profile.field.bankName'),
          field: 'Tên ngân hàng'
        },
        {
          headerName: this.$t('config.profile.field.bankNumber'),
          field: 'Số tài khoản'
        },
        {
          headerName: this.$t('config.profile.field.note'),
          field: 'Ghi chú'
        }
      ]
    }
  },

  watch: {
    value(nv, ov) {
      this.importExcelVisible = nv
    },
    importExcelVisible(nv, ov) {
      if (!nv) {
        this.$emit('input', nv)
      }
    }
  },
  methods: {
    // handle event
    getDataFromExcelFile(result) {
      this.rows = result
    },

    onReset() {
      this.tabIndex = 1 // 1 - 3
      this.rows = []
      this.excelFile = null
      this.excelData = {
        header: null,
        results: null
      }
    },

    // handle api call
    fnGetInvoiceCompanyExcelTemplate() {
      getListInvoiceCompanyExcelTemplateApi(null)
        .then(res => {
          if (!res.is_error) {
            const href = URL.createObjectURL(res)
            // create "a" HTML element with href to file & click
            const link = document.createElement('a')
            link.href = href
            link.setAttribute(
              'download',
              'invoice-company-profile-template.xlsx'
              // res.headers['content-disposition'].split('filename=')[1],
            ) // or any other extension
            document.body.appendChild(link)
            link.click()
            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link)
            URL.revokeObjectURL(href)
          } else {
            throw new Error(res)
          }
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
        .finally(() => {})
    },
    fnInsertListInvoiceCompanyExcel() {
      const formData = new FormData()
      if (this.excelFile) {
        formData.append('excelFile', this.excelFile)
      }

      insertListInvoiceCompanyExcelApi(formData)
        .then(data => {
          if (!data.is_error) {
            this.$message({
              type: 'success',
              message: this.$t(`successMsg.${data.message}`)
            })
            // close dialog
            this.importExcelVisible = false
            this.$emit('resetSearch')
          } else {
            throw new Error(data)
          }
        })
        .catch(error => {
          // {
          //     "is_error": true,
          //     "data": [
          //         {
          //             "line": 2,
          //             "sheet": 0,
          //             "error_list": [
          //                 "invalidEmail"
          //             ]
          //         }
          //     ],
          //     "total": 0
          // }
          if (Array.isArray(error.response?.data?.data?.[0]?.error_list)) {
            const errorList = error.response?.data?.data?.[0]?.error_list
            for (const msg of errorList) {
              this.$message({
                type: 'error',
                message: this.$t(`errorMsg.${msg}`)
              })
            }
          } else {
            const message = error.response?.data?.message || 'default'
            this.$message({
              type: 'error',
              message: this.$t(`errorMsg.${message}`)
            })
          }
        })
        .finally(() => {})
    }

    //
  }
}
</script>
